const CheckIcon = () => {
  return (
    <svg className="check-icon" width="24" height="24" viewBox="0 0 24 24">
      <path d="M10 13.6L15.9 7.7C16.0834 7.51667 16.3167 7.425 16.6 7.425C16.8834 7.425 17.1167 7.51667 17.3 7.7C17.4834 7.88334 17.575 8.11667 17.575 8.4C17.575 8.68334 17.4834 8.91667 17.3 9.1L10.7 15.7C10.5 15.9 10.2667 16 10 16C9.73338 16 9.50005 15.9 9.30005 15.7L6.70005 13.1C6.51672 12.9167 6.42505 12.6833 6.42505 12.4C6.42505 12.1167 6.51672 11.8833 6.70005 11.7C6.88338 11.5167 7.11672 11.425 7.40005 11.425C7.68338 11.425 7.91672 11.5167 8.10005 11.7L10 13.6Z" />
    </svg>
  )
}

export default CheckIcon